/**
 * Revoty Logo Component
 *
 * @param {Object} props - Component props
 * @param {number} props.size - Size of the logo (default: 28)
 * @param {string} props.variant - Logo variant: 'white' or 'colored' (default: 'colored')
 */
export function RevotyLogo({ size = 28, variant = 'colored' }) {
  const scale = size / 141; // Original SVG is 141x141

  if (variant === 'white') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 141 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: 'block' }}
      >
        <path
          d="M88.4399 0C104.543 0.352527 117.098 12.2728 122.248 28.7305C128.083 45.8575 123.676 66.5768 109.544 77.4884C104.222 82.0001 96.3979 85.6554 89.6451 86.3168L140.625 140.625H91.8367C79.3897 127.089 67.2925 114.78 54.7158 101.382C51.0854 98.0673 48.7523 91.8533 52.1234 87.4335L68.289 68.1375C69.3867 66.8274 71.2933 66.7681 72.4593 68.0091L82.6329 78.8469C84.4407 80.7724 87.5315 79.4086 87.5319 76.6853V32.0923C87.5319 30.4038 86.247 29.035 84.662 29.035H42.8018C40.2454 29.0354 38.9652 32.328 40.7727 34.2538L51.0304 45.1812C52.1634 46.3894 52.1467 48.3529 50.9939 49.5402L43.3063 57.461C32.8041 68.3725 21.5236 79.2835 21.1347 95.9962C19.0603 115.195 32.1661 128.747 44.4834 140.625H0V0H88.4399Z"
          fill="white"
        />
      </svg>
    );
  }

  // Colored variant (default)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 141 141"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id="paint0_linear_4023_2672" x1="123.406" y1="32.0923" x2="-1.15315" y2="66.0822" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B8F80"/>
          <stop offset="1" stopColor="#152C35"/>
        </linearGradient>
        <linearGradient id="paint1_linear_4023_2672" x1="107.621" y1="56.5593" x2="63.2564" y2="138.364" gradientUnits="userSpaceOnUse">
          <stop stopColor="#152C35" stopOpacity="0"/>
          <stop offset="0.26136" stopColor="#152C35" stopOpacity="0.516049"/>
          <stop offset="0.506463" stopColor="#152C35"/>
        </linearGradient>
      </defs>
      <path
        d="M88.4399 0C104.543 0.352527 117.098 12.2728 122.248 28.7305C128.083 45.8575 123.676 66.5768 109.544 77.4884C104.222 82.0001 96.3979 85.6554 89.6451 86.3168L140.625 140.625H91.8367C79.3897 127.089 67.2925 114.78 54.7158 101.382C51.0854 98.0673 48.7523 91.8533 52.1234 87.4335L68.289 68.1375C69.3867 66.8274 71.2933 66.7681 72.4593 68.0091L82.6329 78.8469C84.4407 80.7724 87.5315 79.4086 87.5319 76.6853V32.0923C87.5319 30.4038 86.247 29.035 84.662 29.035H42.8018C40.2454 29.0354 38.9652 32.328 40.7727 34.2539L51.0304 45.1812C52.1634 46.3894 52.1467 48.3529 50.9939 49.5402L43.3063 57.461C32.8041 68.3725 21.5236 79.2835 21.1347 95.9962C19.0603 115.195 32.1661 128.747 44.4834 140.625H0V0H88.4399Z"
        fill="url(#paint0_linear_4023_2672)"
      />
      <path
        d="M88.4399 0C104.543 0.352527 117.098 12.2728 122.248 28.7305C128.083 45.8575 123.676 66.5768 109.544 77.4884C104.222 82.0001 96.3979 85.6554 89.6451 86.3168L140.625 140.625H91.8367C79.3897 127.089 67.2925 114.78 54.7158 101.382C51.0854 98.0673 48.7523 91.8533 52.1234 87.4335L68.289 68.1375C69.3867 66.8274 71.2933 66.7681 72.4593 68.0091L82.6329 78.8469C84.4407 80.7724 87.5315 79.4086 87.5319 76.6853V32.0923C87.5319 30.4038 86.247 29.035 84.662 29.035H42.8018C40.2454 29.0354 38.9652 32.328 40.7727 34.2539L51.0304 45.1812C52.1634 46.3894 52.1467 48.3529 50.9939 49.5402L43.3063 57.461C32.8041 68.3725 21.5236 79.2835 21.1347 95.9962C19.0603 115.195 32.1661 128.747 44.4834 140.625H0V0H88.4399Z"
        fill="url(#paint1_linear_4023_2672)"
      />
    </svg>
  );
}
